import styled from "styled-components";
import SectionTitle from "./SectionTitle";
import { useEffect, useMemo, useRef, useState } from "react";
import Card from "./Card";
import FadeInItem from "./FadeInItem";
import { handleLink } from "../utils/handleLink";
import { BREAK_POINT } from "../constants";

const News = () => {
  const newsList = useMemo(
    () => [
      {
        link: "https://www.instagram.com/p/C_9NdcjzLp2/",
        id: "insta_news_132.jpg",
        title: "사랑의 하츄핑 100만 관객 돌파🎉",
        sub: "대한민국 애니메이션 흥행 TOP3🏆",
      },
      {
        link: "https://www.instagram.com/p/C-Y8QpqBp7M/?img_index=1",
        id: "insta_news_80.png",
        title: "<사랑의하츄핑> OST 발매",
        sub: "영화 속 음원을 전부 들어보자!",
      },
      {
        link: "https://www.instagram.com/p/C_1zJ_Cho5R/?img_index=1",
        id: "insta_news_131.jpg",
        title: "우리 포토이즘에서 만나자!",
        sub: "24.09.17 - 24.10.16",
      },

      {
        link: "https://www.instagram.com/p/DAFlS9FB9gV/",
        id: "insta_news_130.jpg",
        title: "개봉 7주차 현장 이벤트",
        sub: "[캐치! 티니핑] 하트 컴팩트",
      },
      {
        link: "https://www.instagram.com/p/C_9k_eEK2-Y/",
        id: "insta_news_129.jpg",
        title: "봐도 봐도 놀라움!!",
        sub: "리암 왕자의 비주얼",
      },
      {
        link: "https://www.instagram.com/p/C_2fzNWS7Er/",
        id: "insta_news_128.jpg",
        title: "윈터핑 포토카드 앵콜 상영회",
        sub: "이거 완전 윈터비키자냐~🍀",
      },

      {
        link: "https://www.instagram.com/p/C_cxmqfhCqF/?img_index=1",
        id: "insta_news_126.jpg",
        title: "추석에도 하츄핑의 축복을!",
        sub: "추석핑 앵콜 무대인사",
      },
      {
        link: "https://www.instagram.com/p/C_2EWBFS3NA/",
        id: "insta_news_125.jpg",
        title: "6주차 추석 현장특전 이벤트",
        sub: "흥행 땡큐 [캐치! 티니핑] 피규어",
      },
      {
        link: "https://www.instagram.com/p/C_wz7ixi2dU/?img_index=1",
        id: "insta_news_127.jpg",
        title: "즐겁고 행복한 추석 만들기",
        sub: "<사랑의하츄핑> 핑핑수월래 특가",
      },
      {
        link: "https://www.instagram.com/p/C_wRjXcv_dS/",
        id: "insta_news_124.jpg",
        title: "풍요롭고 즐거운 한가위",
        sub: "추석맞이 포스터 대공개",
      },
      {
        link: "https://www.instagram.com/p/C_uqkWHMTeu/",
        id: "insta_news_123.jpg",
        title: "사랑의하츄핑 관람후기 특",
        sub: "T도 눈물남🥲",
      },
      {
        link: "https://www.instagram.com/p/C_mSRQ4z8dC/?img_index=1",
        id: "insta_news_122.jpg",
        title: "사랑의하츄핑 90만 돌파",
        sub: "100만까지 쭉쭉 가보자고 츄💕",
      },
      {
        link: "https://www.instagram.com/p/C_eduFTME-q/",
        id: "insta_news_121.jpg",
        title: "김수훈 총감독님 출연",
        sub: "SBS 나이트라인 본방사수!",
      },

      {
        link: "https://www.instagram.com/p/C_P3srGh8n5/",
        id: "insta_news_120.jpg",
        title: "개봉 5주차 현장 이벤트",
        sub: "윈터핑의 포토카드 증정",
      },
      {
        link: "https://www.instagram.com/p/C_POaxTBp_n/",
        id: "insta_news_119.jpg",
        title: "스타필드 마켓 죽전에서 만나!",
        sub: "사랑의 하츄핑 마법 숲속 마을",
      },
      {
        link: "https://www.instagram.com/p/C_PA-dUCnGq/?img_index=1",
        id: "insta_news_118.jpg",
        title: "다 울었니..? 이제 할 일을 하자!",
        sub: "이번 주도 하츄핑을 열일중~",
      },
      {
        link: "https://www.instagram.com/p/C-9vgcTTbnA/",
        id: "insta_news_112.jpg",
        title: "운명의 피규어를 만나봐",
        sub: "메가MGC커피 랜덤 피규어",
      },
      {
        link: "https://www.instagram.com/p/C_IGsN9TzQQ/",
        id: "insta_news_113.jpg",
        title: "어른이를 위한 CGV 컬처위크 특가",
        sub: "8월 28일 단 하루, CGV에서 만나",
      },
      {
        link: "https://www.instagram.com/p/C_AUTyvhROp/",
        id: "insta_news_114.jpg",
        title: "하츄핑 무빙 챌린지",
        sub: "얼빡샷에도 살아남는 귀여움",
      },
      {
        link: "https://www.instagram.com/p/C-__woxIbLC/",
        id: "insta_news_115.jpg",
        title: "80만까지 달려~ 달려!",
        sub: "하츄핑 여정에 함께 해줘서 고마워!",
      },
      {
        link: "https://www.instagram.com/p/C-_kFZQT4CA/",
        id: "insta_news_116.jpg",
        title: "<사랑의 하츄핑> 70만 돌파!",
        sub: "핑크빛으로 물든 극장으로 놀러와💕",
      },
      {
        link: "https://www.instagram.com/p/C-9UxnHhn5i/?img_index=1",
        id: "insta_news_117.jpg",
        title: "같이왔츄 할인 이벤트",
        sub: "여럿이서 보면 할인 폭이 더 커져요!",
      },
      {
        link: "https://www.instagram.com/p/C-7Rlx7KlO0/",
        id: "insta_news_110.jpg",
        title: "트러핑은 무서워🥲",
        sub: "사랑의하츄핑 극장 절찬 상영중",
      },
      {
        link: "https://www.instagram.com/p/C-7Kxp-MPgW/",
        id: "insta_news_109.png",
        title: "싱 위드 하츄핑 특별상영회",
        sub: "가창자 송은혜 배우님의 핑터뷰!",
      },
      {
        link: "https://www.instagram.com/p/C-6TvoRp33q/",
        id: "insta_news_108.jpg",
        title: "하츄핑도 비오는 날은...",
        sub: "출근하기 싫어요🥲",
      },
      {
        link: "https://www.instagram.com/p/C-6tY5PIp0K/",
        id: "insta_news_107.png",
        title: "싱 위드 하츄핑 특별상영회🎵",
        sub: "가창자 송은혜 배우님과 함께해!",
      },
      {
        link: "https://www.instagram.com/p/C-4l62UKWvE/",
        id: "insta_news_106.jpg",
        title: "이 구역의 댄스신동 '하츄핑'",
        sub: "신인 배우로서 최선을 다하겠어 츄!",
      },
      {
        link: "https://www.instagram.com/p/C-4jlRJzOIZ/?img_index=1",
        id: "insta_news_105.jpg",
        title: "개봉 3주차 무대인사 추가 일정",
        sub: "메가박스에서도 하츄핑을 만나봐~!",
      },
      {
        link: "https://www.instagram.com/p/C-3oSBgCUOc/",
        id: "insta_news_104.jpg",
        title: "하이파이브 핑터뷰 GV 이벤트",
        sub: "하츄핑이랑 하이파이브하러 와줘 츄~🖐️",
      },
      {
        link: "https://www.instagram.com/p/C-3oFccJzqI/?img_index=1",
        id: "insta_news_103.jpg",
        title: "개봉 3주차 현장 이벤트",
        sub: "사랑의하츄핑 스마트톡 증정",
      },
      {
        link: "https://www.instagram.com/p/C-2BGKbOMku/",
        id: "insta_news_102.jpg",
        title: "리암왕자를 보는 하츄핑의 표정",
        sub: "또 보고싶다 왕자님..💕",
      },
      {
        link: "https://www.instagram.com/p/C-1bDq-s93A/?img_index=1",
        id: "insta_news_101.jpg",
        title: "개봉 3주차 무대인사 추가 안내",
        sub: "평일에도 하츄핑을 만나볼까?",
      },
      {
        link: "https://www.instagram.com/p/C-1RAxeBBAd/?img_index=1",
        id: "insta_news_100.jpg",
        title: "어떻게 출근까지 사랑하겠어😢",
        sub: "하츄핑을 사랑하는거지~",
      },
      {
        link: "https://www.instagram.com/p/C-wVRGVpukH/",
        id: "insta_news_99.jpg",
        title: "신인 배우 '하츄핑'은 열일 중",
        sub: "프로페셔널한 하츄핑의 모습을 구경해봐!",
      },
      {
        link: "https://www.instagram.com/p/C-wRBrZz56Y/",
        id: "insta_news_98.jpg",
        title: "사랑의하츄핑 60만 관객 돌파!",
        sub: "다들 정말 고마워 츄❤️",
      },
      {
        link: "https://www.instagram.com/p/C-uVT5PT9mL/?img_index=1",
        id: "insta_news_97.png",
        title: "박명수의 라디오쇼 with 하츄핑",
        sub: "김수훈 총감독님과 함께 출연했어 츄!",
      },
      {
        link: "https://www.instagram.com/p/C-uSweZukci/",
        id: "insta_news_96.jpg",
        title: "두근두근 내 마음을 받아줘~💕",
        sub: "하츄핑을 향한 로미의 비행기 플러팅",
      },
      {
        link: "https://www.instagram.com/p/C-uL2hnM3NO/",
        id: "insta_news_95.jpg",
        title: "하츄핑 만나러 송도로 가자!",
        sub: "사랑의하츄핑 월드 in Triple Street",
      },
      {
        link: "https://www.instagram.com/p/C-t-Fyrzwsj/?img_index=1",
        id: "insta_news_94.jpg",
        title: "사랑의 하츄핑 세트 먹자!",
        sub: "사랑의 하츄핑 ♥ 맘스터치",
      },
      {
        link: "https://www.instagram.com/p/C-ti2oFRk6E/?img_index=1",
        id: "insta_news_92.png",
        title: "하츄핑의 일상",
        sub: "내 싸인을 받아볼래 츄~?",
      },
      {
        link: "https://www.instagram.com/p/C-rZWDpzyP2/",
        id: "insta_news_91.jpg",
        title: "박명수의 라디오쇼 출연",
        sub: "8월 16일(금) 오전 11시",
      },
      {
        link: "https://www.instagram.com/p/C-rNRKIzBxU/",
        id: "insta_news_89.jpg",
        title: "사랑의 하츄핑 50만 돌파!",
        sub: "핑크빛 신드롬에 함께해줘 츄💕",
      },
      {
        link: "https://www.instagram.com/p/C-pQBHeBc3t/",
        id: "insta_news_90.png",
        title: "완벽한 리암 왕자님의 용안",
        sub: "왕자님 보기 위해 N차 관람각",
      },
      {
        link: "https://www.instagram.com/p/C-o7e70z9S1/",
        id: "insta_news_88.jpg",
        title: "하츄핑에 진심인 자, 모여라",
        sub: "<사랑의하츄핑> 헤메코 회차 공개",
      },
      {
        link: "https://www.instagram.com/p/C-omyfVPqQc/?img_index=1",
        id: "insta_news_87.jpg",
        title: "윈터를 향한 하츄핑의 마음",
        sub: "윈터핑 다가와 아오에...💖",
      },
      {
        link: "https://www.instagram.com/p/C-mQVoaz4SN/?img_index=1",
        id: "insta_news_86.jpg",
        title: "싱 위드 하츄핑 일정 공개",
        sub: "함께 노래 부르면서 영화 볼까?",
      },
      {
        link: "https://www.instagram.com/p/C-mJMaCz710/",
        id: "insta_news_85.jpg",
        title: "싱 위드 하츄핑 특별상영회!",
        sub: "전국 롯데시네마에서 만나~🎵",
      },
      {
        link: "https://www.instagram.com/p/C-l0PwrT0Fl/?img_index=1",
        id: "insta_news_84.jpg",
        title: "개봉 2주차 현장 이벤트",
        sub: "컬러링 엽서세트 꼭 받아봐❤️",
      },
      {
        link: "https://www.instagram.com/p/C-j_hIxMxAI/",
        id: "insta_news_83.jpg",
        title: "사랑의하츄핑 ❤️ 맘스터치",
        sub: "Eat & play!",
      },
      {
        link: "https://www.instagram.com/p/C-jBuBhInEW/?img_index=1",
        id: "insta_news_82.png",
        title: "NEW 캐릭터 포스터 공개",
        sub: "흥행은 지금부터 시작이야!",
      },
      {
        link: "https://www.instagram.com/p/C-gc9cPzoKU/",
        id: "insta_news_71.jpg",
        title: "사랑의하츄핑 30만 돌파!",
        sub: "많은 사랑과 관심 고마워 츄💕",
      },
      {
        link: "https://www.instagram.com/p/C-cbKB6N0eD/?img_index=1",
        id: "insta_news_72.jpg",
        title: "개봉 3주차 무대인사 일정 공개",
        sub: "많이 보러와줘 츄~♥️",
      },
      {
        link: "https://www.instagram.com/p/C-cDY6vIJJr/",
        id: "insta_news_73.png",
        title: "사랑의하츄핑 ♥ 맘스터치",
        sub: "사랑의 하츄핑 세트 출시!",
      },
      {
        link: "https://www.instagram.com/p/C-ZzOXpCwVq/?img_index=1",
        id: "insta_news_74.png",
        title: "N차 관람 이벤트",
        sub: "한 번으로는 아쉬우니까~",
      },
      {
        link: "https://www.instagram.com/p/C-Zle9eCmcP/",
        id: "insta_news_75.png",
        title: "왕추천 리뷰 인증 이벤트",
        sub: "리뷰 남기고 하츄핑 선물받고!",
      },
      {
        link: "https://www.instagram.com/p/C-ZQ4N9CTPx/",
        id: "insta_news_76.png",
        title: "영화 관람 인증 이벤트",
        sub: "네이버 오픈톡에서 참여해봐!",
      },
      {
        link: "https://www.instagram.com/p/C-ZKA7OPn5m/",
        id: "insta_news_77.jpg",
        title: "사랑의하츄핑 프레임 전격 공개",
        sub: "특별한 추억을 만들어보자!",
      },
      {
        link: "https://www.instagram.com/p/C-XOfyDsULy/",
        id: "insta_news_78.png",
        title: "위기의 순간에 나타난 왕자 리암!",
        sub: "첫눈에 반해버렸다...❤",
      },
      {
        link: "https://www.instagram.com/p/C-W6PrZi07A/?img_index=1",
        id: "insta_news_79.png",
        title: "초대형 하츄핑이 떴다!",
        sub: "롯데월드타워에서 만나봐~",
      },

      {
        link: "https://www.instagram.com/p/C-WXffpSv0N/",
        id: "insta_news_70.jpg",
        title: "메가커피 랜덤 피규어 출시",
        sub: "사랑의하츄핑이 그대로?!",
      },
      {
        link: "https://www.instagram.com/p/C-WJ0dsBQ7c/",
        id: "insta_news_69.png",
        title: "윈터핑 ♥ 하츄핑",
        sub: "윈터핑 포스터 전격 공개",
      },
      {
        link: "https://www.instagram.com/p/C-Uiuo4TZlm/",
        id: "insta_news_68.jpg",
        title: "사랑의하츄핑 월드",
        sub: "송도 트리플스트리트에서 만나!",
      },
      {
        link: "https://www.instagram.com/p/C-WXgmBBw3V/",
        id: "insta_news_67.png",
        title: "윈터의 하츄시그널 공개",
        sub: "윈터도, 하츄핑도 많관부~!",
      },
      {
        link: "https://www.instagram.com/p/C-WQmBMoFh2/",
        id: "insta_news_66.png",
        title: "사랑의하츄핑 대개봉",
        sub: "지금 극장에서 만나봐 츄!",
      },
      {
        link: "https://www.instagram.com/p/C-Ugg7GTKKl/?img_index=1",
        id: "insta_news_65.png",
        title: "어른이 실관람 후기 #2",
        sub: "어른도 하츄시그널 뿅뿅",
      },
      {
        link: "https://www.instagram.com/p/C-UPJG2T678/",
        id: "insta_news_64.jpg",
        title: "전체 예매율 1위",
        sub: "올여름 최고의 블록핑크버스터",
      },
      {
        link: "https://www.instagram.com/p/C-UPCyxTaWH/?img_index=1",
        id: "insta_news_63.jpg",
        title: "개봉주 현장 증정 이벤트",
        sub: "한정판 선물 꼭 챙겨받자!",
      },
      {
        link: "https://www.instagram.com/p/C-UOQo-zAYE/?img_index=1",
        id: "insta_news_62.jpg",
        title: "사랑의하츄핑 굿즈 출시",
        sub: "극장별 굿즈 콤보를 만나봐!",
      },
      {
        link: "https://www.instagram.com/p/C-TyrQqM_RZ/",
        id: "insta_news_61.jpg",
        title: "개봉까지 D-1",
        sub: "사랑의하츄핑 8월 7일 극장대개봉",
      },
      {
        link: "https://www.instagram.com/p/C-SE2tLTtSK/?img_index=1",
        id: "insta_news_60.jpg",
        title: "부산·대구 무대인사 성황리 종료",
        sub: "친구들 만나서 반가웠어 츄!",
      },
      {
        link: "https://www.instagram.com/p/C-Ke8uET2RR/?img_index=1",
        id: "insta_news_59.jpg",
        title: "어른이 실관람객 후기 #1",
        sub: "초특급 귀여움에 빠진 어른들",
      },
      {
        link: "https://www.instagram.com/p/C-KkNzuNPhB/",
        id: "insta_news_58.jpg",
        title: "한국 선수단을 응원합니다!",
        sub: "하츄핑을 만나기 위한 로미의 명승부",
      },
      {
        link: "https://www.instagram.com/p/C-CrsXbBNLp/?img_index=1",
        id: "insta_news_57.png",
        title: "하츄핑 X 파일럿 컬래버레이션",
        sub: "조정석 선배님과의 숨 막히는 만남",
      },
      {
        link: "https://www.instagram.com/p/C-RN5GrKK5H/",
        id: "insta_news_56.png",
        title: "개봉까지 D-2",
        sub: "사랑의하츄핑 8월 7일 극장대개봉",
      },
      {
        link: "https://www.instagram.com/p/C-OpF9UBPOG/",
        id: "insta_news_55.png",
        title: "개봉까지 D-3",
        sub: "사랑의하츄핑 8월 7일 극장대개봉",
      },
      {
        link: "https://www.instagram.com/p/C-METm3JoL8/",
        id: "insta_news_54.png",
        title: "개봉까지 D-4",
        sub: "사랑의하츄핑 8월 7일 극장대개봉",
      },
      {
        link: "https://www.instagram.com/p/C-KdosfiJmV/",
        id: "insta_news_53.jpg",
        title: "처음부터 끝까지 재미있는 영화",
        sub: "배우 ‘강경헌’의 행복한 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-KdWExNA6m/",
        id: "insta_news_52.jpg",
        title: "동심의 세계로 빠질 수 있는 영화",
        sub: "배우 ‘전익령’의 적극추천 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-Kch4hTDCM/?img_index=1",
        id: "insta_news_51.png",
        title: "하츄핑아 사랑해~!",
        sub: "극장에서 심쿵플러팅을 만나봐요.",
      },
      {
        link: "https://www.instagram.com/p/C-KWp_ztyT3/",
        id: "insta_news_50.jpg",
        title: "3대가 재미있게 볼 수 있는 영화",
        sub: "아티스트 '이경민'의 솔직한 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-KWglBobT8/",
        id: "insta_news_49.jpg",
        title: "감동적인 내용에 딸은 오열🥲",
        sub: "모델 ‘아키바리에’의 눈물나는 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-H5OzUqAKj/",
        id: "insta_news_48.jpg",
        title: "아이와 즐거운 추억 만들기",
        sub: "배우 ‘최정윤’의 러블리한 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-H49OdvYz8/",
        id: "insta_news_47.jpg",
        title: "귀에 쏙 들어오는 OST",
        sub: "작곡가 ‘주영훈’의 감미로운 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-H1n03MMrm/",
        id: "insta_news_46.jpg",
        title: "아이와 같이 보기 너무 좋은 영화",
        sub: "축구선수 ‘김진수’의 파이팅한 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-H1bnstAym/",
        id: "insta_news_45.jpg",
        title: "엄마, 아빠도 감동할 영화",
        sub: "딸바보 ‘오종혁’의 사랑가득 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-HzzqiTACj/?img_index=1",
        id: "insta_news_44.jpg",
        title: "개봉 2주차 무대인사 안내",
        sub: "열일하는 하츄핑 보러 와줘!",
      },
      {
        link: "https://www.instagram.com/p/C-FT96yyx-0/",
        id: "insta_news_43.jpg",
        title: "어른이 봐도 사랑스러운 영화",
        sub: "배우 '조성하'의 감동스러운 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-FTtq5MvdX/",
        id: "insta_news_42.jpg",
        title: "우정과 사랑으로 똘똘 뭉친 이야기",
        sub: "배우 '소유진'의 사랑스러운 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-FM7sBOvIO/",
        id: "insta_news_41.jpg",
        title: "하츄핑과의 첫 만남 클립",
        sub: "이거 꿈 아니지?",
      },
      {
        link: "https://www.instagram.com/p/C-FHiS5MOX_/",
        id: "insta_news_40.jpg",
        title: "한국판 <겨울왕국>을 본 기분",
        sub: "가수 '바다'의 극찬 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-FHaEKPRrM/",
        id: "insta_news_39.jpg",
        title: "K애니메이션의 놀라운 발전",
        sub: "방송인 '유병재'의 유쾌한 리뷰",
      },
      {
        link: "https://www.instagram.com/p/C-EV5NNNgDN/",
        id: "insta_news_38.jpg",
        title: "D-1WEEK",
        sub: "백마'된' 왕자 리암의 등장",
      },
      {
        link: "https://www.instagram.com/p/C-BjXmXB59L/",
        id: "insta_news_37.png",
        title: "하츄핑 무대인사 암표 근절 안내",
        sub: "불법적인 경로로 티켓 구매 금지",
      },
      {
        link: "https://www.instagram.com/p/C9_8avooKZU/",
        id: "insta_news_36.png",
        title: "포토위젯으로 폰꾸하자!",
        sub: "<사랑의 하츄핑> 테마 출시",
      },
      {
        link: "https://www.instagram.com/p/C9_1geJM0TN/?img_index=1",
        id: "insta_news_35.png",
        title: "처음 본 순간 상영회 오픈",
        sub: "개봉 전 <사랑의 하츄핑>을 먼저 만나봐!",
      },
      {
        link: "https://www.instagram.com/p/C9_vtzSTAaM/?img_index=1",
        id: "insta_news_34.jpg",
        title: "레드카펫에 선 하츄핑",
        sub: "VIP 시사회 현장 대공개",
      },
      {
        link: "https://www.instagram.com/p/C9_MWnKzr0H/",
        id: "insta_news_33.jpg",
        title: "윈터가 선택한 영화!",
        sub: "<사랑의 하츄핑> 많관부~❤️",
      },

      {
        link: "https://www.instagram.com/p/C96QeKUvdFE/",
        id: "insta_news_32.png",
        title: "윈터와 함께한 네컷 사진 공개",
        sub: "하츄핑 프레임으로 추억을 남겨봐!",
      },
      {
        link: "https://www.instagram.com/p/C94Om6OzvTz/",
        id: "insta_news_31.jpg",
        title: "사랑의 하츄핑 팝콘 출시",
        sub: "전국 GS25 매장에서 만나 츄",
      },
      {
        link: "https://www.instagram.com/p/C94LqfezJ_4/?img_index=1",
        id: "insta_news_30.jpg",
        title: "개봉주 무대인사",
        sub: "하츄핑과 직접 만나볼 수 있는 기회!",
      },
      {
        link: "https://www.instagram.com/p/C93sb1ZN9qZ/",
        id: "insta_news_29.png",
        title: "하츄핑도 영화보러 왔어 츄!",
        sub: "예매 오픈 기념 극장 방문 츄~",
      },
      {
        link: "https://www.instagram.com/p/C93sKF6yL5D/",
        id: "insta_news_28.jpg",
        title: "예매 전격 오픈",
        sub: "극장에서 만날 준비 됐지?",
      },
      {
        link: "https://www.instagram.com/p/C90rcmgz6Xo/?img_index=1",
        id: "insta_news_27.jpg",
        title: "캐릭터 포스터 전격 공개!",
        sub: "K-애니메이션의 핑크빛 비주얼",
      },
      {
        link: "https://www.instagram.com/p/C9zKP6LTmRF/?img_index=1",
        id: "insta_news_26.png",
        title: "하츄핑크닉존 포토 이벤트",
        sub: "롯데월드타워 7층 씨네파크에서 만나",
      },
      {
        link: "https://www.instagram.com/p/C9yiIgHMPzj/",
        id: "insta_news_25.png",
        title: "윈터 OST 비하인드 영상",
        sub: "처음 본 순간 나는 빠져버렸어❄️",
      },
      {
        link: "https://www.instagram.com/p/C9yUXEBBfgP/",
        id: "insta_news_24.png",
        title: "D-2WEEK",
        sub: "8월 7일 스크린에서 만나!",
      },
      {
        link: "https://www.instagram.com/p/C9t7ZsJTrYV/?img_index=1",
        id: "insta_news_23.png",
        title: "하츄핑 서울숲 등장!",
        sub: "다음에는 어디로 갈까?",
      },
      {
        link: "https://www.instagram.com/p/C9t61vnTvji/?img_index=1",
        id: "insta_news_22.jpg",
        title: "첫 무대인사 데뷔❤️",
        sub: "이번 주말도 많이 기대해줘~!",
      },
      {
        link: "https://www.instagram.com/p/C9oO7VviySn/",
        id: "insta_news_21.jpg",
        title: "윈터💗하츄핑 3종 하트.zip",
        sub: "내 하트를 받아줘 츄~",
      },
      {
        link: "https://www.instagram.com/p/C9l-1yzzsIs/?img_index=1",
        id: "insta_news_20.png",
        title: "사랑의하츄핑 ♥ 포토이즘",
        sub: "전국 포토이즘에서 만나 츄~!",
      },
      {
        link: "https://www.instagram.com/p/C9gndARz90Y/",
        id: "insta_news_19.jpg",
        title: "What's in 마이핑",
        sub: "윈터와 함께하는 굿즈 언박싱!",
      },
      {
        link: "https://www.instagram.com/p/C9dxXYSzK0h/?img_index=1",
        id: "insta_news_18.jpg",
        title: "부산 & 대구에 하츄핑이 뜬다!",
        sub: "지금 무대인사 예매하러 가자!",
      },
      {
        link: "https://www.instagram.com/p/C9RYWAMNE83/",
        id: "insta_news_17.png",
        title: "인스타그램 스토리 스티커 출시",
        sub: "하츄핑 스티커 구경가자!",
      },
      {
        link: "https://www.instagram.com/p/C9RW1QWzE7Q/?img_index=1",
        id: "insta_news_16.jpg",
        title: "<사랑의 하츄핑> 무대인사 일정",
        sub: "하츄핑 보러 와줄거지?",
      },
      {
        link: "https://www.instagram.com/p/C9RmG0wuByi/?img_index=1",
        id: "insta_news_15.jpg",
        title: "<사랑의 하츄핑> 메인 예고편",
        sub: "기대가득 💗이벤트에 참여해봐!",
      },
      {
        link: "https://www.instagram.com/p/C9Q2GE7qC1n/",
        id: "insta_news_14.jpg",
        title: "'처음 본 순간' 댄스 챌린지🎵",
        sub: "하츄핑 단독 무대도 감상해요!",
      },
      {
        link: "https://www.instagram.com/p/C9ELz8-MTUt/",
        id: "insta_news_13.jpg",
        title: "‘처음 본 순간’ 댄스 챌린지🎵",
        sub: "윈터와 함께 춤춰봐요~!",
      },
      {
        link: "https://www.instagram.com/p/C9Bt2Ffvp8L/",
        id: "insta_news_12.jpg",
        title: "윈터랑 함께했어 츄~",
        sub: "OST에 참여한 윈터의 소감은?",
      },
      {
        link: "https://www.instagram.com/p/C88B6vxiqIy/",
        id: "insta_news_11.jpg",
        title: "처음 본 순간 - 윈터",
        sub: "음원 발매 시작!",
      },
      {
        link: "https://www.instagram.com/p/C85dHCpKmRf/",
        id: "insta_news_10.jpg",
        title: "메인 포스터 공개",
        sub: "8월 7일 극장에서 만나요!",
      },
      {
        link: "https://www.instagram.com/p/C83T0ecppse/?img_index=1",
        id: "insta_news_9.jpg",
        title: "하츄핑크 모집",
        sub: "<사랑의 하츄핑> 서포터즈",
      },
      {
        link: "https://www.instagram.com/p/C8vzJEFJ2VG/",
        id: "insta_news_8.jpg",
        title: "네이버 오픈톡 오픈",
        sub: "자유롭게 대화해보자!",
      },
      {
        link: "https://www.instagram.com/p/C8vQzatBNcs/",
        id: "insta_news_7.jpg",
        title: "'처음 본 순간' OST 주인공",
        sub: "윈터 of aespa",
      },
      {
        link: "https://www.instagram.com/p/C8tiefFvV5Z/",
        id: "insta_news_6.jpg",
        title: "하츄핑하우스에 놀러올래?",
        sub: "티니핑월드 인 판교에서 만나요!",
      },
      {
        link: "https://www.instagram.com/p/C8slIgvs5Sx/",
        id: "insta_news_5.png",
        title: "소울메이트 포스터 공개",
        sub: "8월 7일 극장 대개봉!",
      },
      {
        link: "https://www.instagram.com/p/C8Y8k7FMcfi/",
        id: "insta_news_4.jpg",
        title: "캐치! 티니핑 드림페스타",
        sub: "대전 현대 프리미엄 아울렛에서\n만나요!",
      },
      {
        link: "https://www.instagram.com/p/C8YMhrtvV2i/",
        id: "insta_news_3.png",
        title: "밤하늘 포스터 공개",
        sub: "8월 최초 극장 개봉 확정",
      },
      {
        link: "https://www.instagram.com/p/C7nd-3zhgOv/",
        id: "insta_news_2.jpg",
        title: "티니핑크닉 개최",
        sub: "동탄 레이크꼬모에서 만나요!",
      },
      {
        link: "https://www.instagram.com/p/C51wtSUMqzM/",
        id: "insta_news_1.jpg",
        title: "론칭 아트 대공개",
        sub: "올여름 극장에서 만나요!",
      },
    ],
    []
  );

  const [open, setOpen] = useState(false);
  const mouseDownRef = useRef(false);
  const newsListRef = useRef<HTMLDivElement>(null);
  const positionRef = useRef<{ clientX: number; scrollLeft: number }>({
    clientX: 0,
    scrollLeft: 0,
  });

  useEffect(() => {
    newsListRef.current?.addEventListener("mousedown", (e: MouseEvent) => {
      mouseDownRef.current = true;

      if (positionRef?.current && newsListRef.current) {
        positionRef.current.clientX = e.pageX - newsListRef.current.offsetLeft;
        positionRef.current.scrollLeft = newsListRef.current.scrollLeft;
      }
    });

    newsListRef.current?.addEventListener("mouseup", (e: MouseEvent) => {
      mouseDownRef.current = false;
    });

    newsListRef.current?.addEventListener("mouseleave", () => {
      mouseDownRef.current = false;
    });

    newsListRef.current?.addEventListener("mousemove", (e: MouseEvent) => {
      e.preventDefault();

      if (!mouseDownRef.current) return;
      if (positionRef?.current && newsListRef.current) {
        const x = e.pageX - newsListRef.current.offsetLeft;
        const walk = x - positionRef.current.clientX;
        newsListRef.current.scrollLeft = positionRef.current.scrollLeft - walk;
      }
    });

    newsListRef.current?.addEventListener("click", (e: MouseEvent) => {
      if (
        window.innerWidth < 1150 &&
        positionRef.current.clientX !== e.clientX
      ) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }, []);

  return (
    <Wrapper id="news">
      <SectionTitle>NEWS</SectionTitle>
      <FadeInItem point={0.25}>
        <NewsWrapper $open={open}>
          <div ref={newsListRef}>
            {newsList.map((news) => (
              <Card
                key={news.id}
                id={news.id}
                title={news.title}
                sub={news.sub}
                handleClick={() => handleLink(news.link)}
              />
            ))}
            <Empty></Empty>
          </div>
        </NewsWrapper>
      </FadeInItem>
      <LoadMoreButton onClick={() => setOpen(!open)}>
        <img
          src={open ? "/assets/icon_more_close.png" : "/assets/icon_more.png"}
          alt="close more"
        />
      </LoadMoreButton>
    </Wrapper>
  );
};

export default News;

const Wrapper = styled.div`
  padding: 140px 0 62px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 1150px) {
    padding: 80px 0 4px;
  }
`;

const NewsWrapper = styled.div<{ $open?: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    @media only screen and (min-width: 1150px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 30px;
      margin-top: 100px;
      overflow: hidden;
      will-change: max-height;
      max-height: ${({ $open }) => ($open ? "22000px" : "968px")};
      transition: ${({ $open }) => ($open ? "max-height 1s linear" : "")};
    }

    @media only screen and (max-width: 1150px) {
      width: 100%;
      display: flex;
      gap: 16px;
      padding: 0 16px;
      overflow-x: scroll;
      margin-top: 24px;
    }
  }
`;

const LoadMoreButton = styled.div`
  cursor: pointer;
  margin-top: 50px;

  @media only screen and (max-width: 1150px) {
    display: none;
  }
`;

const Empty = styled.div`
  display: none;

  @media only screen and (min-width: 1150px) {
    display: block;
    width: 30%;
  }

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    min-width: 360px;
    max-width: 384px;
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    min-width: 320px;
    white-space: pre;
  }
`;
